import { guidedUseCaseService } from '@/services/guided-use-case-service';

/**
 * @param {string|undefined} canvasKey - a single canvas, or undefined for every canvas
 * @returns {Promise<string>} the filename the sheet was saved under
 */
export async function downloadTemplate(canvasKey?: string): Promise<string> {
  const { blob, filename } = await guidedUseCaseService.downloadTemplate(canvasKey);
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
  return filename;
}
